// cookies-dialog.controller.js
"use strict";

class cookiesDialogController {
    constructor($timeout) {
        this.$timeout = $timeout;
        this.editando = false;
    }

    $onInit() {
        this.analytics = false;
        this.comport = false;
    }

    editar() {
        this.editando = true;
        this.$timeout(() => {
            const cerrar = document.getElementById('cookiesCerrarEdicion');
            if (cerrar) {
                cerrar.focus();
            }
        });
    }

    cerrarEdicion() {
        this.editando = false;
        this.$timeout(() => {
            const editar = document.getElementById('cookiesEditar');
            if (editar) {
                editar.focus();
            }
        });
    }

    onAccept() {
        this.accept({analytics:this.analytics, comport: this.comport});
    }

    onAcceptAll() {
        this.analytics = true;
        this.comport = true;
        this.accept({analytics:this.analytics, comport:this.comport});
    }
}

cookiesDialogController.$inject = ["$timeout"];

export { cookiesDialogController as COOKIES_DIALOG_CONTROLLER };
